import React, { useEffect, useState, FC } from 'react'

import { Box, FILTER_CONTROLLER_EVENTS, FiltersController, useSyncFilterValue } from '@centra/centra-ui'

import styled from './FilterComponent.module.scss'

import { FILTER_COMPONENT_TYPE } from '../consts'
import { TPlatformFiltersType } from '../models'

interface IFilterComponent {
  controller: FiltersController
  query: string
  filterName: string
  label: string
  pinnedFilters: string | null
}
export const FilterComponent: FC<IFilterComponent> = ({ controller, query, filterName, label, pinnedFilters }) => {
  const [isPinned, setIsPinned] = useState(false)

  const predicate = useSyncFilterValue({ controller })

  useEffect(() => {
    if (pinnedFilters) {
      const arr = JSON.parse(pinnedFilters)
      setIsPinned(arr.includes(filterName))
    }
  }, [pinnedFilters])

  const scheme = useSyncFilterValue({ controller, event: FILTER_CONTROLLER_EVENTS.SCHEME })

  const activeFilter = scheme.get(filterName)

  const Component = FILTER_COMPONENT_TYPE[activeFilter?.type as TPlatformFiltersType]

  if (isPinned) {
    return (
      <Box className={activeFilter?.type !== 'dateRange' ? styled.container : ''}>
        <Component
          controller={controller}
          filterName={filterName}
          predicate={predicate}
          query={query}
          notInModal
          label={label}
        />
      </Box>
    )
  }
  return null
}
